<template>
  <el-dialog class="chooseMap" append-to-body :visible.sync="visible" :title="type === 1 ? '选择上车位置' : '选择下车位置'"
    width="740px" :before-close="closeFn" :close-on-click-modal="false">
    <div class="map-search">
      <div>
        <span>地图搜索</span>
        <choose-address :value.sync="value" placeholder="在地图上搜索位置" :citycode="cityAdcode"
          @clickRowFn="clickRowFn"></choose-address>
      </div>
      <div>
        <span>其他出发地</span>
        <el-select v-show="type == 1" @change="selectChange($event, 1)" :value="startId" placeholder="请选择上车点">
          <el-option v-for="item in startStationRail" :key="item.id"
            :label="item.stationName + (item.stationType == 1 ? ' (站点)' : ' (围栏)')" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-show="type == 2" @change="selectChange($event, 2)" :value="endId" placeholder="请选择下车点">
          <el-option v-for="item in endStationRail" :key="item.id"
            :label="item.stationName + (item.stationType == 1 ? ' (站点)' : ' (围栏)')" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div id="order-form-map"></div>
    <div v-if="type == 1" class="order-form-marker-text">
      {{ scope ? address.name : "上车点不在运营区域内" }}
    </div>
    <div v-if="type == 2" class="order-form-marker-text">
      {{ scope ? address.name : "下车点不在运营区域内" }}
    </div>
    <img v-if="showPoint" class="order-form-marker" src="../../../assets/img/marke.png" alt="" />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveClick" :disabled="!scope">{{ type === 1 ? "确认上车点" : "确认下车点" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import AMap from "AMap";

export default {
  name: "chooseMap",
  props: {
    type: {
      // 地址类型，1-上车位置，2-下车位置
      default() {
        return 1;
      },
    },
    visible: {
      // 弹框显示/隐藏
      default() {
        return true;
      },
    },
    address: {
      // 选中的位置信息
      default() {
        return {};
      },
    },
    startStationRail: {
      default() {
        return [];
      },
    },
    endStationRail: {
      default() {
        return [];
      },
    },
    startId: {
      default() {
        return null;
      },
    },
    endId: {
      default() {
        return null;
      },
    },

  },
  data() {
    return {
      map: null,
      marker: null,
      // 地图搜索-城市
      cityAdcode: "",
      // 地图搜索-默认值
      value: "",
      scope: false, // 是否在围栏内
      chooseStation: null,
      showPoint: true,
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.value = "";
            this.initMap();
          });
        }
      },
      immediate: true,
      deep: true,
    },

  },
  methods: {
    /* 下拉框变化 */
    selectChange(value, type) {
      // 拿到该站点/围栏
      this.chooseStation = this[type == 1 ? 'startStationRail' : 'endStationRail'].find(val => val.id == value)
      console.log('chooseStation', this.chooseStation)
      this.$emit(`update:${this.type == 1 ? 'startId' : 'endId'}`, this.chooseStation.id);
      if (this.Mark) {
        this.map.remove(this.Mark)
        this.Mark = null
      }
      console.log('chooseStation', this.chooseStation)
      // 定位
      if (this.chooseStation.stationType == 1) {
        console.log('if')
        this.showPoint = false;
        this.getMarker(this.chooseStation.longitude, this.chooseStation.latitude, 1, this.chooseStation.stationName)
        setTimeout(() => {
          this.drawMarker();
        }, 350);
        this.map.setStatus({
          dragEnable: false,
          zoomEnable: false,
        })
      } else {
        console.log('else')
        this.showPoint = true;
        let center;
        //最大经纬度与中间经纬度
        let longitudeMax = 0;
        let longitudeMin = 99999;

        let latitudeMax = 0;
        let latitudeMin = 99999;
        let path = JSON.parse(this.chooseStation.enclosureAddress);
        console.log('path', path)
        path[0][0].map((item) => {
          if (item.lng > longitudeMax) {
            longitudeMax = item.lng;
          } else if (item.lng < longitudeMin) {
            longitudeMin = item.lng;
          }

          if (item.lat > latitudeMax) {
            latitudeMax = item.lat;
          } else if (item.lat < latitudeMin) {
            latitudeMin = item.lat;
          }
        });
        center = [
          longitudeMin + (longitudeMax - longitudeMin) / 2,
          latitudeMin + (latitudeMax - latitudeMin) / 2,
        ];
        this.map.setCenter(center);
        setTimeout(() => {
          this.drawMarker();
        }, 350);
        this.map.setStatus({
          dragEnable: true,
          zoomEnable: true,
        })
      }
    },
    /* 地图搜索-选择单项 */
    async clickRowFn(res) {
      this.value = null;
      this.chooseStation = null;
      this.map.setCenter([res.location.lng, res.location.lat]);
      setTimeout(() => {
        this.drawMarker();
      }, 500);
    },
    /* 绘制站点marker */
    getMarker(longitude, latitude) {
      let position = new AMap.LngLat(longitude, latitude);
      this.Mark = new AMap.Marker({
        map: this.map,                 // 地图实例对象
        position: position,            // 标记位置
        // anchor: "bottom-center",       // 设置锚点方位
        animation: "AMAP_ANIMATION_DROP", // 标记掉落效果
        icon: require("@/assets/img/markerBegin.png"),
        offset: new AMap.Pixel(-2, 0),
      });
      this.map.panTo(position);
    },
    /* 高德：绘制围栏多边形 */
    amapPolygon(path) {
      new AMap.Polygon({
        map: this.map,
        path: path,
        fillColor: "#0288FF",
        fillOpacity: "0.3",
        strokeColor: "#0288FF",
        strokeOpacity: 1,
      });
      this.map.setFitView();
    },
    /* 初始化地图 */
    initMap() {
      this.map = new AMap.Map("order-form-map", {
        mapStyle: 'amap://styles/572516903e2f1273ed9c97f54ebacd89',
        resizeEnable: true,
        center: new AMap.LngLat(104.065861, 30.657401),
      });

      this.cityAdcode = this.map.getAdcode();

      // 缩放结束
      this.map.on("zoomend", () => {
        setTimeout(() => {
          this.drawMarker();
        }, 10)
      });
      // 拖拽结束
      this.map.on("dragend", () => {
        this.drawMarker()
      });
      this[this.type == 1 ? 'startStationRail' : 'endStationRail'].map(item => {
        if (item.stationType == 2) {
          this.amapPolygon(JSON.parse(item.enclosureAddress));
        }
      })
      if (this.type == 1) {
        this.showPoint = this.startStationRail[0].stationType != 1;
        this.selectChange(this.startId, 1);
      } else if (this.type == 2) {
        this.showPoint = this.endStationRail[0].stationType != 1;
        this.selectChange(this.endId, 2);
      }

    },
    /* 视野变化 */
    async drawMarker() {
      // 获取地图中心点
      let resCenter = this.map.getCenter();
      if (resCenter.lat && resCenter.lng) {
        this.isFenceRange(resCenter.lat, resCenter.lng);
      }
      let lnglat = `${resCenter.lng},${resCenter.lat}`;
      let regeo = await this.$AMap.AMapReGeo(lnglat);
      let pois = regeo.regeocode.pois;
      pois.sort((a, b) => a.distance - b.distance);
      let name = pois && pois.length > 0 ? pois[0].name : regeo.regeocode.formatted_address;
      let addr = pois && pois.length > 0 && pois[0].address && pois[0].address.length > 0 ? pois[0].address : regeo.regeocode.formatted_address;

      let address = {
        type: this.type,
        city: regeo.regeocode.addressComponent.city && regeo.regeocode.addressComponent.city.length > 0
          ? regeo.regeocode.addressComponent.city : regeo.regeocode.addressComponent.province,
        longitude: resCenter.lng,
        latitude: resCenter.lat,
        name: this.chooseStation?.stationType == 1 ? this.chooseStation.stationName : name,
        address: addr,
      };
      this.$emit("update:address", address);
    },

    isFenceRange(latitude, longitude) {
      if (this.chooseStation?.stationType == 1) {
        this.scope = true;
      } else {
        let arr = [];

        this[this.type == 1 ? 'startStationRail' : 'endStationRail'].map((item) => {
          if (item.stationType == 2) {
            let oooj = this.isRange(JSON.parse(item.enclosureAddress), latitude, longitude, item);
            arr.push(oooj);
          }
        })

        let obj = arr.find((val) => val.bool == true);
        if (obj) {
          this.scope = true;
          this.chooseStation = obj.chooseRail;
          this.$emit(`update:${this.type == 1 ? 'startId' : 'endId'}`, this.chooseStation.id);
        } else {
          this.scope = false;
          this.chooseStation = null;
          this.$emit(`update:${this.type == 1 ? 'startId' : 'endId'}`, null);
        }
      }
    },
    /* 判断当前点是否在电子围栏以内 */
    isRange(path, latitude, longitude, chooseRail) {
      let obj;
      for (let index = 0; index < path.length; index++) {
        let item = path[index];
        if (item.length === 1) {
          let bool = this.customPointPolygon(latitude, longitude, item[0]);
          obj = { bool: bool, chooseRail: chooseRail };
          if (bool) {
            break;
          }
        } else if (item.length > 1) {
          let tag = false;
          item.forEach((val, i) => {
            if (i > 0) {
              let bool2 = this.customPointPolygon(latitude, longitude, item[i]);
              if (bool2) {
                tag = true;
              }
            }
          });
          let bool1 = this.customPointPolygon(latitude, longitude, item[0]);
          if (bool1) {
            if (!tag) {
              obj = { bool: true, chooseRail: chooseRail };
            } else {
              obj = { bool: false, chooseRail: chooseRail };
            }
            break;
          } else {
            obj = { bool: false, chooseRail: chooseRail };
          }
        }
      }
      return obj;
    },
    /**
     * 判断点是否在多边形范围以内
     * @param {*} aLat
     * @param {*} aLon
     * @param {*} pointList
     */
    customPointPolygon(aLat, aLon, pointList) {
      var iSum = 0;
      var iCount = pointList.length;
      if (iCount < 3) {
        return false;
      }
      for (var i = 0; i < iCount; i++) {
        var pLat2 = "";
        var pLon2 = "";
        var pLat1 = pointList[i].lat;
        var pLon1 = pointList[i].lng;
        if (i == iCount - 1) {
          pLat2 = pointList[0].lat;
          pLon2 = pointList[0].lng;
        } else {
          pLat2 = pointList[i + 1].lat;
          pLon2 = pointList[i + 1].lng;
        }
        if ((aLat >= pLat1 && aLat < pLat2) || (aLat >= pLat2 && aLat < pLat1)) {
          if (Math.abs(pLat1 - pLat2) > 0) {
            var pLon = pLon1 - ((pLon1 - pLon2) * (pLat1 - aLat)) / (pLat1 - pLat2);
            if (pLon < aLon) {
              iSum += 1;
            }
          }
        }
      }
      if (iSum % 2 != 0) {
        return true;
      } else {
        return false;
      }
    },

    closeFn() {
      this.$emit("update:visible", false);
    },
    saveClick() {
      if (this.type == 1) {
        this.$emit("update:startId", this.startId);
      } else {
        this.$emit("update:endId", this.endId);
      }
      this.$emit("confirm", this.address);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="less">
.chooseMap {
  /deep/ .markerLabel {
    padding: 1rem 1.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffffff;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

    &.start {
      background-color: #0289ff91;
    }

    &.end {
      background-color: #228b2291;
    }
  }

  .map-search {
    display: flex;
    padding-bottom: 16px;
    align-items: center;

    &>div {
      margin-right: 40px;

      &>span {
        margin-right: 15px;
      }

      .el-select {
        width: 200px;

        .el-input__inner {
          padding-right: 15px;
        }
      }
    }
  }

  .el-dialog__body {
    position: relative;

    .order-form-marker {
      position: absolute;
      top: 50%;
      left: 50%;
      right: 50%;
      bottom: 50%;
      z-index: 10000;
      color: #0288ff;
      font-size: 20px;
      transform: translateX(-50%) translateY(-50%);
      margin-top: 10px;
    }

    .order-form-marker-text {
      position: absolute;
      top: calc(50% - 40px);
      left: 50%;
      transform: translateX(-50%);
      z-index: 10000;
      background-color: #fff;
      line-height: 17px;
      font-size: 14px;
      padding: 6px 16px;
      box-shadow: 2px 2px 6px 0px rgba(3, 136, 255, 0.2);
      border-radius: 14px;
      color: #061d37;
      white-space: nowrap;
      max-width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  #order-form-map {
    width: 100%;
    height: 50vh;
    position: relative;
    z-index: 0;
  }
}
</style>
